const _ECOMMERCE_FLASHY_EVENT = {
    VIEW_CONTENT: 'view_content',
    UPDATE_CART: 'update_cart',
    CREATE_OR_UPDATE: 'create_or_update',
    PURCHASE: 'purchase'
};
function sendFlashyEcommerceEvent(eventName, data, newsLetterType, ClubNewsetterGroupID, GeneralNewsetterGroupID) {
    if (newsLetterType == 'flashy') {
        try {
            switch (eventName) {
                case _ECOMMERCE_FLASHY_EVENT.VIEW_CONTENT:
                    sendFlashyViewContent(data);
                    break;
                case _ECOMMERCE_FLASHY_EVENT.UPDATE_CART:
                    sendFlashyUpdateCart(data);
                    break;
                case _ECOMMERCE_FLASHY_EVENT.CREATE_OR_UPDATE:
                    sendFlashyCreateOrUpdate(data, ClubNewsetterGroupID, GeneralNewsetterGroupID);
                    break;
                case _ECOMMERCE_FLASHY_EVENT.PURCHASE:
                    sendFlashyPurchase(data)
                    break;
            }
        } catch (ex) {
            console.error('Flashy failed, %o', ex);
        }
    }
    else {
        console.error('Flashy is not initialized. Skipping Flashy event.');
    }
}
function sendFlashyViewContent(productIds) {
    const data = {
        "content_ids": productIds
    };
    console.log('flashy added object %o', data);
    
    window.parent.postMessage(JSON.stringify({type:'flashy', eventName:'ViewContent', data:data}), "*")
    
}

function sendFlashyUpdateCart(data) {
    const cartData = {
        'content_ids': data.content_ids,
		'value': data.value,
		'currency': data.currency
    };
    window.parent.postMessage(JSON.stringify({type:'flashy', eventName:'UpdateCart', data:data}), "*")
    
    console.log('Flashy added object %o', cartData);
}

function sendFlashyCreateOrUpdate(data, ClubNewsetterGroupID, GeneralNewsetterGroupID) {
    const customerData = {
        "email": data.email,
        "first_name": data.first_name,
        "last_name": data.last_name,
        "lists": {}
    };
    // Set the dynamic groupId with default value
    if (data.groupId) {
        customerData.lists[data.groupId] = data.acceptNews;
    }

    // Add "lists" only if isNewsletter is true
    if (data.isNewsletter) {
        if (ClubNewsetterGroupID) {
            customerData.lists[ClubNewsetterGroupID] = true;
        } else if (GeneralNewsetterGroupID) {
            customerData.lists[GeneralNewsetterGroupID] = true;
        } else {
            console.error('Both ClubNewsetterGroupID and GeneralNewsetterGroupID are empty or null.');
            return;
        }
    }

        window.parent.postMessage(JSON.stringify({type:'flashy', eventName:'createOrUpdate', data:data}), "*")
    
    console.log('flashy added object %o', customerData);
}

function sendFlashyPurchase(data) {
    const purchaseData = {
        'content_ids': data.content_ids,
        'value': data.value,
        'currency': data.currency,
        'order_id': data.order_id
    };
    console.log('flashy added object %o', purchaseData);
    window.parent.postMessage(JSON.stringify({type:'flashy', eventName:'Purchase', data:data}), "*")
    
}

export { sendFlashyEcommerceEvent, _ECOMMERCE_FLASHY_EVENT }